// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"08a2aa88","918":"8d80d6a4"}[chunkId] + ".chunk.js";
};